import { useEffect } from 'react';
import { AxiosErrorHandler, Col, Loading, Row, SadFaceIcon, Text, Title } from 'ui';
import { useEmailUnsubscribeMutation } from '../queries';

type P = {
  token?: string;
};

const Unsubscribe = ({ token }: P) => {
  const { error, isPending, mutate: unsubscribe } = useEmailUnsubscribeMutation();

  useEffect(() => {
    if (token) {
      unsubscribe({ token });
    }
  }, [token, unsubscribe]);

  if (isPending) {
    return <Loading />;
  }

  return (
    <AxiosErrorHandler error={error}>
      <Row align="middle" justify="center">
        <Col>
          <SadFaceIcon />
          <Title level={2} marginBottom>
            We are sad to see you go!
          </Title>
          <Text>You have successfully unsubscribed, you will no longer receive this type of emails.</Text>
        </Col>
      </Row>
    </AxiosErrorHandler>
  );
};

export default Unsubscribe;
